import React from 'react';
import { Cover, Button, LinkButton } from 'seduo-ui';
const Example = () => (<Cover color="brand-dark" title={`This is hero text <span class="text-brand-orange">with color</span>`} description="lorem ipsum dolor sit amet" images={[
        'https://seduocz.educdn.cz/static/images/employer/cards@1x.png',
        'https://seduocz.educdn.cz/static/images/employer/cards@2x.png 2x',
    ]} leftButton={<Button color="primary" block>
                Primary Button link
            </Button>} rightButton={<LinkButton color="white" underline>
                Link button underline
            </LinkButton>} rightButtonDelimiter={<span>or</span>}/>);
export default Example;
